"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _selectors = require("../../../redux/selectors");
var _PwhCPipes = _interopRequireDefault(require("./PwhCPipes"));
var _HotSpotBox = _interopRequireDefault(require("../Models/HotSpotBox"));
var _Device = _interopRequireDefault(require("../Models/Device"));
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const {
  ComponentTypes,
  LoopType,
  SectionTypes,
  sensorTypes
} = _paulCorePackage.constants;
var _default = props => {
  const type = ComponentTypes.PwhC;
  const modelShow = (0, _reactRedux.useSelector)((0, _selectors.selectStructureShowModelByType)(type));
  const modelPosition = (0, _reactRedux.useSelector)((0, _selectors.selectStructurePositionsByType)(type));
  const equipmentId = (0, _reactRedux.useSelector)(_selectors.selectActivePwhC);
  const showBox = false;
  if (!modelShow) return null;
  return /*#__PURE__*/_react.default.createElement("group", _extends({
    position: modelPosition
  }, props), /*#__PURE__*/_react.default.createElement(_PwhCPipes.default, {
    position: [0, 0, 0]
  }), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 2 * _constants.verticalPipeSpacing, -6],
    showBox: showBox,
    pipe: _constants.pipesTypes.circulation
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.circulation,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      }
    },
    requiredTypeNot: sensorTypes.pump,
    cardPosition: [3, 8, -6.5]
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 2 * _constants.verticalPipeSpacing, -15],
    showBox: showBox,
    pipe: _constants.pipesTypes.circulation
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.circulation,
    requiredType: sensorTypes.pump,
    anywayShow: true,
    panelPosition: [0, -4, -3]
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 3 * _constants.verticalPipeSpacing, -15],
    showBox: showBox,
    pipe: _constants.pipesTypes.hotWater
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.none,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      }
    }
  }))));
};
exports.default = _default;